import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import EmergencyContacts from "./pages/EmergencyContacts";
import AirportServices from "./pages/AirportServices";
import DepartureFlights from "./pages/DepartureFlights";
import ServiceStart from "./pages/ServiceStart";
import Announcements from "./pages/Announcements";
import RobotFleet from "./pages/RobotFleet";
import FaceDetections from "./pages/FaceDetections";
import ManageRobots from "./pages/ManageRobots";
import POILocations from "./pages/POILocations";
import CategoryMaster from "./pages/CategoryMaster";
import ManageProfile from "./pages/ManageProfile";
import ThemeSettings from "./pages/ThemeSettings";
import ManageMapLocations from "./pages/ManageMapLocations";
import ManageAdmins from "./pages/ManageAdmins";
import ManageUsers from "./pages/ManageUsers";
import RolePermissions from "./pages/RolePermissions";
import UserPermissions from "./pages/UserPermissions";
import EmailConfiguration from "./pages/EmailConfiguration";
import SendEmail from "./pages/SendEmail";
import ResetPasswordFirebase from "./pages/ResetPasswordFirebase";
import VerifyMobileOtp from "./pages/VerifyMobileOtp";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePreferences from "./pages/CookiePreferences";
import ContactSupport from "./pages/ContactSupport";

// Layout
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleRoute from "./components/RoleRoute";
import { ROLE_SUPERADMIN, ROLE_ADMIN } from "./utils/auth";


function App() {
  return (
    <BrowserRouter>

      <Routes>

        {/* Login -- only at / */}
        <Route path="/" element={<Login />} />

        <Route path="/forgot-password" element={<ResetPasswordFirebase />} />

        <Route path="/verify-mobile" element={<VerifyMobileOtp />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/terms-of-service" element={<TermsOfService />} />

        <Route path="/cookie-preferences" element={<CookiePreferences />} />

        <Route path="/contact-support" element={<ContactSupport />} />

        {/* Admin Layout -- guarded, redirects to / if not authenticated */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >

          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/manage-profile" element={<ManageProfile />} />

          <Route path="/robot-fleet" element={<RobotFleet />} />

          <Route path="/face-detections" element={<FaceDetections />} />

          <Route path="/manage-robots" element={<ManageRobots />} />

          <Route path="/poi-locations" element={<POILocations />} />

          <Route path="/category-master" element={<CategoryMaster />} />

          <Route path="/map-locations" element={<ManageMapLocations />} />

          <Route
            path="/manage-admins"
            element={
              <RoleRoute allowedRoles={[ROLE_SUPERADMIN]}>
                <ManageAdmins />
              </RoleRoute>
            }
          />

          <Route
            path="/manage-users"
            element={
              <RoleRoute allowedRoles={[ROLE_SUPERADMIN, ROLE_ADMIN]}>
                <ManageUsers />
              </RoleRoute>
            }
          />

          <Route
            path="/role-permissions"
            element={
              <RoleRoute allowedRoles={[ROLE_SUPERADMIN]}>
                <RolePermissions />
              </RoleRoute>
            }
          />

          <Route
            path="/user-permissions"
            element={
              <RoleRoute allowedRoles={[ROLE_SUPERADMIN, ROLE_ADMIN]}>
                <UserPermissions />
              </RoleRoute>
            }
          />

          <Route
            path="/email-configuration"
            element={
              <RoleRoute allowedRoles={[ROLE_SUPERADMIN]}>
                <EmailConfiguration />
              </RoleRoute>
            }
          />

          <Route path="/theme-settings" element={<ThemeSettings />} />

          <Route
            path="/send-email"
            element={<SendEmail />}
          />

          <Route
            path="/emergencycontacts"
            element={<EmergencyContacts />}
          />

          <Route
            path="/airport-services"
            element={<AirportServices />}
          />

          <Route
            path="/airport-announcement"
            element={<Announcements />}
          />

          <Route
            path="/departure-flights"
            element={<DepartureFlights />}
          />

          <Route
            path="/service-start"
            element={<ServiceStart />}
          />

        </Route>

        {/* Invalid Route */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>

      {/* Global Toast */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />

    </BrowserRouter>
  );
}

export default App;